/**
 * Styled Components - Created by eduardo on 11/01/19.
 */
import styled from 'styled-components'
import { GRAY_DARK, WHITE } from '../../../theme/colors'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  & .ant-tabs-tab {
    margin: 0;
  }
  @media (max-width: 698px) {
    justify-content: left;
  }
`

interface ColorProps {
  color?: string
  selected?: boolean
}

interface StyledProps {
  selected?: boolean
  withBorder?: boolean
  marginLeft?: string
  disabled?: boolean
  highlight?: boolean
}

export const Color = styled.img`
  cursor: pointer;
  width: 32px;
  height: 32px;
  filter: brightness(
    ${({ selected }: ColorProps) => (selected ? '285%' : '100%')}
  );
  transform: scale(${({ selected }: ColorProps) => (selected ? '0.8' : '1')});
  transition: transform 0.3s ease-in-out;
`

export const Col = styled.div`
  display: inline-block;
  list-style: none;
  margin: 0 4px;
  text-align: center;
`

export const ColorModal = styled.div`
  text-align: center;
  overflow: overlay;
  display: flex;
  visibility: ${({ selected }: ColorProps) =>
    selected ? 'visible' : 'hidden'};
  position: relative;
  transition: all 0.25s ease;
  flex-flow: row;
  background: white;
  padding: 8px;
  box-shadow: 0px 2px 6px -2px black;
  border-radius: 8px;
  margin-bottom: -70px;
  z-index: 2;
  opacity: ${({ selected }: ColorProps) => (selected ? '1' : '0')};
`

export const ColorModalDesktop = styled.div`
  text-align: center;
  overflow: overlay;
  display: flex;
  visibility: ${({ selected }: ColorProps) =>
    selected ? 'visible' : 'hidden'};
  position: relative;
  transition: all 0.25s ease;
  flex-flow: row;
  background: white;
  padding: 8px;
  box-shadow: 0px 2px 6px -2px black;
  border-radius: 8px;
  margin-bottom: -70px;
  z-index: 2;
  opacity: ${({ selected }: ColorProps) => (selected ? '1' : '0')};
  flex-wrap: wrap;
  width: 214px;
  position: absolute;
  top: 0;
  z-index: 7;
  left: 0;
  justify-content: center;
  padding-bottom: 2px;
  padding-right: 0px;
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 28px;
  padding: 0px 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const ColorOptionModal = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 28px;
  padding: 0px 10px;
  transition: all .25s;
  margin-bottom: 10px;
  margin-right: 10px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 11px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  box-shadow: 1px 2px 2px 0px #e1e1e1;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemTable/ColorPicker/styledComponents.tsx